"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var colors_1 = require("../ThemeProvider/colors");
var Typography_1 = __importDefault(require("../Typography"));
var BadgeSecondary = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'info' : _b, typographyProps = _a.typographyProps, sx = _a.sx;
    return (react_1.default.createElement(Box_1.default, { component: "div", ref: ref, sx: __assign({ display: 'inline-block', alignItems: 'center', backgroundColor: variant === 'archived'
                ? colors_1.tannerGray['600']
                : colors_1.tannerSemantic[variant].color, border: 'none', borderRadius: 1, color: colors_1.tannerWhite, px: '3px' }, sx) },
        react_1.default.createElement(Typography_1.default, __assign({}, typographyProps, { sx: __assign({ lineHeight: '16px', color: 'inherit', fontWeight: 800, fontSize: 12 }, typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.sx) }), children)));
});
exports.default = BadgeSecondary;
//# sourceMappingURL=index.js.map